import styled from 'styled-components';

export const TableWrapper = styled.div<{ borderTop?: boolean }>`
  ${({ theme, borderTop }) =>
    borderTop &&
    `
    & table {
      border-top: 0.0625rem solid ${theme.colors.discrete20};
    }
  `}
  margin: 0 1rem;
  > * th {
    border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.discrete20};
  }
  > * th:nth-child(2) {
    text-align: left;
  }
  > * td {
    vertical-align: middle;
    padding: 0.75rem inherit;
  }
  > * td:first-child {
    padding-left: 1rem;
  }
`;
